export function addLogRecord(data) {
  return { type: 'ADD_LOG_RECORD', data };
}
